module.exports = "<div id=\"login-form\" class=\"row\" ng-class=\"{ 'compact' : config.compactLayout || isMobile() }\">\n  <div class=\"col-sm-6 col facebook\">\n    <login-facebook config=\"config\" callback=\"done\">\n    </login-facebook>\n  </div>\n  <div class=\"col-sm-6 col email\">\n    <login-email config=\"config\" callback=\"done\">\n    </login-email>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/login/template.html
// module id = 855
// module chunks = 1